import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const en = {
  painterops: {
    sync: {
      local:        'Local Mode',
      localTitle:   'Working offline — changes save to this device only',
      cloud:        'Cloud Synced',
      cloudTitle:   'Connected to your account',
      syncing:      'Syncing…',
      syncingTitle: 'Saving changes to the cloud',
      error:        'Sync Error',
      errorTitle:   'Tap to retry — changes are queued locally',
    },
    chemLog: {
      title:                  'Log Chemistry',
      loggingFor:             'Logging chemistry for',
      freeChlorineLong:       'Free Chlorine (ppm)',
      phLong:                 'pH',
      alkalinityLong:         'Alkalinity (ppm)',
      cyaLong:                'CYA (ppm)',
      notesSection:           'Service Notes',
      notesPlaceholderLong:   'Anything the next tech should know…',
      submitModal:            'Save Chemistry',
    },
    addInvoice: {
      title:                  'Create Invoice',
      customerLabel:          'Customer',
      customerPlaceholder:    'Select a customer…',
      serviceLabel:           'Service',
      servicePlaceholder:     'e.g. Monthly service, equipment repair',
      amountLabel:            'Amount ($)',
      amountPlaceholder:      '0',
      dueLabel:               'Due Date',
      submit:                 'Create & Send Invoice',
    },
  },
  common: {
    actions: {
      cancel: 'Cancel',
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources: { en },
    lng: 'en',
    fallbackLng: 'en',
    ns: ['painterops', 'common'],
    defaultNS: 'painterops',
    interpolation: { escapeValue: false },
    returnNull: false,
  });

export default i18n;
